import { useState } from 'react';

/**
 * Export the displayed expenses. `onExport('xlsx' | 'pdf')` builds and downloads
 * the file; a thrown error is shown next to the buttons.
 */
const ExportMenu = ({ onExport, disabled }) => {
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState('');

  const run = async (format) => {
    try {
      setBusy(format);
      setError('');
      await onExport(format);
    } catch (err) {
      setError(`Couldn't build the report: ${err?.message || err}`);
    } finally {
      setBusy(null);
    }
  };

  const button = (format, label, icon) => (
    <button
      type="button"
      className="btn btn-outline-secondary btn-sm"
      onClick={() => run(format)}
      disabled={disabled || Boolean(busy)}
      title={disabled ? 'Nothing to export with these filters' : `Download the displayed expenses as ${label}`}
    >
      {busy === format ? (
        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
      ) : (
        <i className={`bi ${icon} me-1`} aria-hidden="true"></i>
      )}
      {label}
    </button>
  );

  return (
    <div className="d-flex align-items-center gap-2">
      <div className="btn-group" role="group" aria-label="Export">
        {button('xlsx', 'Excel', 'bi-file-earmark-spreadsheet')}
        {button('pdf', 'PDF', 'bi-file-earmark-pdf')}
      </div>
      {error && <span className="text-danger small" role="alert">{error}</span>}
    </div>
  );
};

export default ExportMenu;
